export default "__VITE_ASSET__eb8ffcfd__"